import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Btn, CustomModal, Loading } from '../../../../../components'
import { tableCellCentered } from '../../../../../assets/js/styles'
import BadgeStatusCte from '../../../../../components/BadgeStatusCte/BadgeStatusCte'
import {
  getMdfesDisponiveisVinculo,
  postVincularRotaMdfe,
} from '../../../../../services/api/https/deliveries/mdfe.http'
import { NOMES_TIPO_EMITENTE_MDFE, estiloDicaCiot, formatarDataHora } from '../../Ciot/ciot.util'

export default function ModalVincularMdfeRota({
  visible,
  fleetId,
  placa,
  onClose,
  onVinculado,
  onError,
}) {
  const [mdfes, setMdfes] = useState([])
  const [carregando, setCarregando] = useState(false)
  const [vinculando, setVinculando] = useState(null)

  useEffect(() => {
    if (!visible || !fleetId) return
    let ativo = true
    setCarregando(true)
    getMdfesDisponiveisVinculo(fleetId)
      .then(lista => ativo && setMdfes(lista))
      .catch(error => ativo && onError(error))
      .finally(() => ativo && setCarregando(false))
    return () => {
      ativo = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, fleetId])

  const onVincularClicked = async mdfe => {
    setVinculando(mdfe.id)
    try {
      await postVincularRotaMdfe(mdfe.id, fleetId)
      onVinculado(mdfe)
    } catch (error) {
      onError(error)
    } finally {
      setVinculando(null)
    }
  }

  return (
    <CustomModal
      isVisible={visible}
      header="Vincular MDFe à rota"
      style={{ width: '90vw', maxWidth: 850 }}
      contentStyle={{ maxHeight: '75vh', overflowY: 'auto' }}
      onClose={onClose}
    >
      <div className="p-grid">
        <div className="p-col-12" style={estiloDicaCiot}>
          MDFes autorizados do veículo {placa} que ainda não estão vinculados a nenhuma rota. Ao
          vincular, o MDFe passa a aparecer nesta rota e pode ser encerrado no retorno do veículo.
        </div>
        <div className="p-col-12">
          {carregando ? (
            <div className="text-center" style={{ marginTop: 20, marginBottom: 20 }}>
              <Loading />
            </div>
          ) : (
            <DataTable value={mdfes} emptyMessage="Nenhum MDFe disponível para este veículo">
              <Column
                header="Número"
                body={mdfe => mdfe.numero || mdfe.ref}
                style={tableCellCentered(110)}
              />
              <Column field="emissor_razao_social" header="Emitente" />
              <Column
                header="Tipo de emitente"
                body={mdfe => NOMES_TIPO_EMITENTE_MDFE[mdfe.tipo_emitente] || '-'}
              />
              <Column
                header="Percurso"
                style={tableCellCentered(90)}
                body={mdfe => `${mdfe.uf_inicio || ''} → ${mdfe.uf_fim || ''}`}
              />
              <Column
                header="Status"
                style={tableCellCentered(120)}
                body={mdfe => <BadgeStatusCte status={mdfe.status} />}
              />
              <Column
                header="Emitido em"
                style={tableCellCentered(130)}
                body={mdfe => formatarDataHora(mdfe.created_at)}
              />
              <Column
                style={tableCellCentered(110)}
                body={mdfe => (
                  <Btn isLoading={vinculando === mdfe.id} onClick={() => onVincularClicked(mdfe)}>
                    Vincular
                  </Btn>
                )}
              />
            </DataTable>
          )}
        </div>
      </div>
    </CustomModal>
  )
}
